
import SearchIcon from "@mui/icons-material/Search"; // Add this import
import { InputAdornment } from "@mui/material";
import { StyledIconButton, StyledSearchBar } from './SearchBar.styles';

const SearchBar = ({searchTerm, setSearchTerm, placeholder = "Search"}) => {

    return (
        <StyledSearchBar
        variant="outlined"
        placeholder={placeholder}
        fullWidth
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <StyledIconButton>
                <SearchIcon />
              </StyledIconButton>
            </InputAdornment>
          ),
        }}
      />
    );
}

export default SearchBar;
